<!-- 管理端-月报管理 -->
<template>
  <div class="project_index_main">
    <div class="project_breadcrumb_box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>项目列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="project_header_box">
      <h2>我的项目</h2>
      <p>选择项目进入月报管理</p>
    </div>

    <!-- 搜索区域 -->
    <div class="search-box">
      <div class="search-item">
        <el-input v-model="search.keyword" placeholder="关键词" size="small" clearable @clear="init" @keyup.enter.native="init"></el-input>
      </div>
      <div class="search-item">
        <el-select v-model="search.organ_id" placeholder="机构名称" size="small" clearable filterable style="width:100%">
          <el-option v-for="item in orgOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <el-select v-model="search.month_status" placeholder="月报状态" size="small" clearable filterable style="width:100%">
          <el-option label="审核中" value="submitted"></el-option>
          <el-option label="已审核" value="approved"></el-option>
          <el-option label="已驳回" value="rejected"></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <el-select v-model="search.month_report" placeholder="月份" size="small" clearable style="width:100%">
          <el-option v-for="m in monthOptions" :key="m" :label="m" :value="m"></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <el-date-picker v-model="search.time" value-format="yyyy-MM-dd" end-placeholder="结束日期"
          range-separator="至" start-placeholder="开始日期" type="daterange" size="small" style="width:100%">
        </el-date-picker>
      </div>
      <div class="search-item">
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="searchReset">重置</el-button>
        <el-button type="primary" size="small" icon="el-icon-search" @click="searchFun" style="margin-left:10px">搜索</el-button>
      </div>
      <div class="search-item">
        <el-button type="success" size="small" icon="el-icon-download" @click="exportReport">导出月报汇总</el-button>
      </div>
    </div>

    <div class="project_list_box">
      <div class="project_list" v-if="projectList.length > 0">
        <div class="project_list_item" v-for="(item, index) in projectList" :key="index">
          <div class="project_list_item_header">
            <div class="project_list_item_name">{{ item.project_name }}</div>
          </div>
          <div class="project_list_item_content">
            <div class="project_list_item_info">
              <div class="project_list_item_menu">
                <p>报告月份</p>
                <h2 style="color: #3381c3">{{ item.month_time || '暂无' }}</h2>
              </div>
              <div class="project_list_item_menu">
                <p>月报状态</p>
                <h2 class="yellow">{{ item.month_status || '未提交' }}</h2>
              </div>
            </div>
          </div>
          <div class="project_list_item_handle">
            <el-button class="project_list_item_report" size="small" @click="goDetail(item)">查看详情</el-button>
          </div>
        </div>
      </div>
      <div class="project_empty_box" v-else><p>暂无项目数据</p></div>
      <div class="project_page_box" v-if="search.total > search.limit">
        <el-pagination background layout="prev, pager, next"
          :total="search.total" :page-size="search.limit" :current-page.sync="search.page"
          @current-change="init"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { adminGetProjectList } from "@/api/adminModule";
import { getOrganPassList } from "@/api/admin";
import { baseURL } from "@/config";

export default {
  data() {
    return {
      orgOptions: [], monthOptions: [],
      search: { keyword: '', organ_id: '', month_status: '', month_report: '', time: [], page: 1, limit: 6, total: 0 },
      projectList: [],
    };
  },
  created() {
    this.$emit("setActive", { active: 10 });
    for (let i = 7; i <= 12; i++) this.monthOptions.push('2026年' + i + '月');
    this.searchInit();
    this.init();
  },
  methods: {
    async searchInit() {
      const res = await getOrganPassList();
      if (res && res.code === 200) this.orgOptions = (res.data || []).map(v => ({ value: v.id, label: v.organ_name }));
    },
    searchFun() { this.search.page = 1; this.init(); },
    searchReset() {
      this.search = { keyword: '', organ_id: '', month_status: '', month_report: '', time: [], page: 1, limit: 6, total: 0 };
      this.init();
    },
    async init() {
      const s = this.search;
      const res = await adminGetProjectList({
        keyword: s.keyword, organ_id: s.organ_id, month_status: s.month_status, month_report: s.month_report,
        begin_time: s.time && s.time.length > 0 ? s.time[0] : '',
        end_time: s.time && s.time.length > 0 ? s.time[1] : '',
        pageIndex: s.page, pageSize: s.limit,
      });
      if (res && res.code === 200) { this.projectList = res.data.data || []; this.search.total = res.data.total || 0; }
    },
    /** 导出月报汇总 */
    exportReport() {
      const month = this.search.month_report || '2026年7月';
      window.open(baseURL + '/admin/NewModule/exportReportSummary' + '?month_report=' + encodeURIComponent(month), '_blank');
    },
    goDetail(item) { this.$router.push({ path: '/adminhome/report/detail', query: { projectId: item.id } }); },
  },
};
</script>

<style scoped lang="scss">
@import url("index.scss");
</style>
